/**
 *
 * DrawerActionPlan
 *
 */

import React, { Component } from "react"
import { get, isEqual, map, debounce, find, flatMap } from "lodash"
import { Drawer, Tabs, Input, Button, Avatar } from "antd"
import "./index.less"
import ModalCustom from "components/ModalCustom"
import alertSvg from "images/alert.svg"
import { saveActionPlanApi } from "services/actionPlans"
import Loader from "components/Loader"

import {
  getActionPlans,
  getComments,
  createComment,
  markReadComment,
  markReadActionPlan,
} from "./api"
import ActionPlanCard from "../ActionPlanCard"
import ModalActionPlanCreate from "../ModalActionPlanCreate"

import CommentItem from "./CommentItem"
import EmptyStateComments from "./EmptyStateComments"
import EmptyStateActionsPlans from "./EmptyStateActionsPlans"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import {
  isModuleBySlug,
  LOCAL_USER_ID,
  LOCAL_USER_PHOTO,
} from "../../utils/storage"
import { ACTION_PLANS } from "../../utils/constants"
import { loadTexts } from "../../utils/i18n"

const { TabPane } = Tabs
const { Search, TextArea } = Input

/* eslint-disable react/prefer-stateless-function */
class DrawerActionPlan extends Component {
  intl = loadTexts("tracking")
  state = {
    actionPlans: [],
    comments: [],
    loadingComments: false,
    comment: "",
    modalActionPlanEditId: null,
    modalArchivePlan: false,
    modalArchiveLoading: false,
    currentPlan: {},
    searchValue: "",
  }

  callback = (key) => {
    const { initialData } = this.props

    if (key === "1") {
      markReadActionPlan({
        data: {
          id_measure: initialData.id_measure,
          id_division: initialData.id_division,
          id_dimension: initialData.id_dimension,
        },
      })
    }

    if (key === "2") {
      markReadComment({
        data: {
          id_measure: initialData.id_measure,
          id_division: initialData.id_division,
          id_dimension: initialData.id_dimension,
        },
      })
    }
  }

  setStateFrom = (values) => this.setState(values)

  searchActionPlansSearch = async (value) => {
    const { initialData } = this.props

    const actionPlans = await getActionPlans({
      params: {
        measure: initialData.id_measure,
        division: initialData.id_division,
        dimension: initialData.id_dimension,
        search: value,
      },
    })

    this.setState({ actionPlans, loadingComments: false })
  }

  searchActionPlansSearchDebounce = debounce(this.searchActionPlansSearch, 500)

  updateActionPlansAndComments = async () => {
    this.setState({ loadingComments: true })
    const { initialData } = this.props

    const actionPlans = await getActionPlans({
      params: {
        measure: initialData.id_measure,
        division: initialData.id_division,
        dimension: initialData.id_dimension,
      },
    })
    const comments = await getComments({
      params: {
        id_measure: initialData.id_measure,
        id_division: initialData.id_division,
        id_dimension: initialData.id_dimension,
      },
    })

    this.props.getDimensions(true)
    this.setState({ actionPlans, comments, loadingComments: false })
  }

  componentDidMount() {
    this.updateActionPlansAndComments()
  }

  componentDidUpdate = async (prevProps, prevState, snapshot) => {
    const { initialData } = this.props

    if (!isEqual(prevProps.initialData, initialData) && initialData) {
      this.updateActionPlansAndComments()
    }
  }

  render() {
    const {
      visible,
      initialData,
      divisions,
      drawerActionPlanOpenIn,
    } = this.props
    const {
      actionPlans,
      comments,
      modalArchivePlan,
      modalArchiveLoading,
    } = this.state
    const countCommets = flatMap(comments, (item) => item.replies)
    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    return (
      <Drawer
        width={524}
        placement="right"
        visible={visible}
        bodyStyle={{ padding: 0 }}
        className="container-actionplan"
        title={
          <div className="container-actionplan__title">
            {get(initialData, "dimension_name", "")}
            <span
              style={{ backgroundColor: get(initialData, "color", "#e37879") }}>
              {get(initialData, "value_visible", "0%")}
            </span>
          </div>
        }
        onClose={() => {
          this.props.setStateFrom({
            drawerActionPlan: false,
            dimensionSelected: undefined,
          })
        }}>
        <Tabs
          defaultActiveKey={drawerActionPlanOpenIn}
          onChange={this.callback}
          animated={false}
          className="container-actionplan__tabs">
          <TabPane
            key="1"
            tab={`Planes de acción ${
              actionPlans.length ? `(${actionPlans.length})` : ""
            }`}>
            {actionPlans.length ||
            !!this.state.searchValue.length ||
            !!initialData.action_plan.count ? (
              <React.Fragment>
                <div className="container-actionplan__search">
                  <Search
                    placeholder={this.intl.drawerActionPlan.search}
                    value={this.state.searchValue}
                    onChange={(event) => {
                      this.searchActionPlansSearchDebounce(event.target.value)
                      this.setState({
                        searchValue: event.target.value,
                        loadingComments: true,
                      })
                    }}
                  />
                  {isActionPlans && (
                    <Button
                      type="primary"
                      onClick={() => {
                        woopraTrack("Crear plan de acción")
                        this.setState({
                          modalActionPlanCreate: true,
                          modalActionPlanEditId: null,
                        })
                      }}>
                      {this.drawerActionPlan.create}
                    </Button>
                  )}
                </div>
                {!actionPlans.length && initialData.comment.count ? (
                  this.state.loadingComments ? (
                    <Loader />
                  ) : (
                    <EmptyStateActionsPlans setStateFrom={this.setStateFrom} />
                  )
                ) : (
                  <div className="container-actionplan__plans">
                    {map(actionPlans, (item, index) => {
                      return (
                        <ActionPlanCard
                          key={index}
                          item={item}
                          canCreateTask
                          canOpen
                          canEdit={
                            item.id === parseInt(LOCAL_USER_ID()) ||
                            item.created_by_id === parseInt(LOCAL_USER_ID()) ||
                            validRole({ role: [1, 2, 3, 4] })
                          }
                          onEdit={(e) => {
                            this.setState({
                              modalActionPlanCreate: true,
                              modalActionPlanEditId: item.id_action_plan,
                            })
                          }}
                          onArchive={(e) => {
                            this.setState({
                              modalArchivePlan: true,
                              currentPlan: item,
                            })
                          }}
                          onReloadActionPlan={(e) => {
                            actionPlans[index] = Object.assign(
                              actionPlans[index],
                              e
                            )
                            this.setState({ actionPlans })
                          }}
                        />
                      )
                    })}
                  </div>
                )}
              </React.Fragment>
            ) : (
              <EmptyStateActionsPlans setStateFrom={this.setStateFrom} />
            )}
          </TabPane>

          <TabPane
            key="2"
            tab={`Comentarios ${
              countCommets.length || comments.length
                ? `(${comments.length + countCommets.length})`
                : ""
            }`}>
            {comments.length ? (
              <React.Fragment>
                <div className="container-actionplan__comments">
                  {map(comments, (comment, index) => {
                    return (
                      <CommentItem
                        setStateFrom={this.setStateFrom}
                        initialData={initialData}
                        key={index}
                        getDimensions={this.props.getDimensions}
                        {...comment}>
                        {map(comment.replies, (item, indexItem) => {
                          return (
                            <CommentItem
                              {...item}
                              getDimensions={this.props.getDimensions}
                              initialData={initialData}
                              key={`${index}-${indexItem}-${item.id_user}`}
                              noResponse
                              setStateFrom={this.setStateFrom}
                            />
                          )
                        })}
                      </CommentItem>
                    )
                  })}
                </div>

                <div className="container-actionplan__footer">
                  <div className="container-actionplan__add-comment">
                    <Avatar size={64} src={LOCAL_USER_PHOTO()} />
                    <TextArea
                      rows={4}
                      value={this.state.comment}
                      onChange={(event) =>
                        this.setState({ comment: event.target.value })
                      }
                    />
                  </div>
                  <div className="container-actionplan__add-comment-btns">
                    <Button
                      onClick={() => {
                        this.setState({ comment: "" })
                        /* this.props.setStateFrom({
                          drawerActionPlan: false,
                          dimensionSelected: undefined
                        }) */
                      }}>
                      Cancelar
                    </Button>
                    <Button
                      type="primary"
                      disabled={!this.state.comment}
                      loading={this.state.loadingComments}
                      onClick={async () => {
                        this.setState({ loadingComments: true })
                        const { initialData } = this.props
                        const sharedData = {
                          id_measure: initialData.id_measure,
                          id_division: initialData.id_division,
                          id_dimension: initialData.id_dimension,
                        }

                        await createComment({
                          data: {
                            ...sharedData,
                            message: this.state.comment,
                          },
                        })
                        const comments = await getComments({
                          params: sharedData,
                        })
                        this.props.getDimensions(true)
                        this.setState({
                          comment: "",
                          comments,
                          loadingComments: false,
                        })
                      }}>
                      Comentar
                    </Button>
                  </div>
                </div>
              </React.Fragment>
            ) : this.state.loadingComments ? (
              <Loader />
            ) : (
              <EmptyStateComments
                getDimensions={this.props.getDimensions}
                initialData={initialData}
                setStateFrom={this.setStateFrom}
              />
            )}
          </TabPane>
        </Tabs>
        <ModalActionPlanCreate
          visible={this.state.modalActionPlanCreate}
          modalActionPlanEditId={this.state.modalActionPlanEditId}
          stylePdaLast={{ top: 0, height: "100%" }}
          finish={() => {
            this.updateActionPlansAndComments()
          }}
          onCancel={() => this.setState({ modalActionPlanCreate: false })}
          initialData={{
            measure: initialData && initialData.id_measure,
            division: {
              id_division: initialData && initialData.id_division,
              division_name:
                initialData &&
                find(
                  divisions,
                  (item) => item.id_division === initialData.id_division
                )?.name,
            },
            dimensions: [initialData && initialData.id_dimension],
          }}
        />
        <ModalCustom
          modalOpen={modalArchivePlan}
          showFooter
          textButton="Archivar"
          onOk={async () => {
            this.setState({ modalArchiveLoading: true })
            try {
              const result = await saveActionPlanApi({
                id: this.state.currentPlan.id_action_plan,
                archived: 1,
              })
              this.setState({
                modalArchivePlan: false,
                modalArchiveLoading: false,
                currentPlan: {},
              })
              this.updateActionPlansAndComments()
              returnMessage(result)
            } catch (error) {
              this.setState({
                modalArchivePlan: false,
                modalArchiveLoading: false,
              })
              returnMessage(error)
            }
          }}
          onCancel={() => {
            this.setState({ modalArchivePlan: false })
          }}
          isLoadingButton={modalArchiveLoading}>
          <div className="component-deletesimple">
            <img src={alertSvg} className="alertIcon" />
            <div className="component-deletesimple__description">
              <p>
                <b>{this.intl.drawerActionPlan.ModalCustom.title}</b>
              </p>
              <p>{this.intl.drawerActionPlan.ModalCustom.body}</p>
            </div>
          </div>
        </ModalCustom>
      </Drawer>
    )
  }
}

export default DrawerActionPlan
